export default "__VITE_ASSET__DU93NilY__"